import { HUBSPOT_LOGO, SF_LOGO, CSV } from "./images";
import { FEATURES_NAME } from "./features";

export const FORM_FIELD = "FORM_FIELD";
export const SOURCE_FIELD = "SOURCE_FIELD";

export const CRM_NAMES = {
  SALESFORCE: "Salesforce",
  HUBSPOT: "Hubspot",
};

export const CRM_URL_PARAMS = {
  SALESFORCE: "salesforce",
  HUBSPOT: "hubspot",
  CSV: "csv",
};

export const CRM_SHORT_NAMES = {
  SALESFORCE: "SF",
  HUBSPOT: "HS",
  BOX: "BOX",
  CSV: "CSV",
};

export const CRM_SHORT_NAMES_MAPPING = {
  [CRM_URL_PARAMS.SALESFORCE]: CRM_SHORT_NAMES.SALESFORCE,
  [CRM_URL_PARAMS.HUBSPOT]: CRM_SHORT_NAMES.HUBSPOT,
  [CRM_URL_PARAMS.CSV]: CRM_SHORT_NAMES.CSV,
};

export const CRM_INTEGRATIONS = [
  {
    name: CRM_URL_PARAMS.SALESFORCE,
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.SALESFORCE],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.SALESFORCE}`,
    logopath: SF_LOGO,
    featureName: FEATURES_NAME.INTG_SALESFORCE_STANDARD,
    scopes: false,
  },
  {
    name: CRM_URL_PARAMS.HUBSPOT,
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.HUBSPOT],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.HUBSPOT}`,
    logopath: HUBSPOT_LOGO,
    featureName: "intg.hubspot",
    scopes: true,
  },
  {
    name: CRM_URL_PARAMS.CSV,
    id: CRM_SHORT_NAMES_MAPPING[CRM_URL_PARAMS.CSV],
    fullpath: `/settings/integrations/${CRM_URL_PARAMS.CSV}`,
    logopath: CSV,
    featureName: "intg.csv",
    scopes: true,
  },
];

export const CRM_INTEGRATIONS_LOGOS = {
  Hubspot: HUBSPOT_LOGO,
  Salesforce: SF_LOGO,
  CSV,
};
